import React from "react";
import {Box, Link, Text, useColorModeValue} from "@chakra-ui/react";

export default function Footer() {
    const backgroundColor = useColorModeValue("light", "darkprimary");
    const textColor = useColorModeValue("primary", "light");
    const borderColor = useColorModeValue("secondary", "primary");
    const linkColor = useColorModeValue("primary", "secondary");
    const currentYear = new Date().getFullYear();

    return (
        <Box
            as="footer"
            position="fixed"
            bottom={{base: "60px", lg: 0}}
            left={0}
            w="100%"
            py={{base: "1rem", md: "1.5rem"}}
            px={{base: "1rem", md: "2rem"}}
            textAlign="center"
            bg={backgroundColor}
            color={textColor}
            borderTopWidth="1px"
            borderColor={borderColor}
            boxShadow="md"
            zIndex={90}
        >
            <Text fontSize={{base: "0.75rem", md: "0.875rem"}} lineHeight="1.4" mb="0.5rem">
                Δράση ενίσχυσης επενδύσεων «Εμβληματικές δράσεις σε διαθεματικές επιστημονικές περιοχές με ειδικό ενδιαφέρον για την σύνδεση με τον παραγωγικό ιστό» / Ανθεκτικότητα, Συμπερίληψη και Ανάπτυξη: Προς μια Δίκαιη Πράσινη και Ψηφιακή Μετάβαση των Ελληνικών Περιφερειών – TAEDR-0537352.
            </Text>
            <Text fontSize={{base: "0.75rem", md: "0.875rem"}} lineHeight="1.4">
                Η δράση υλοποιείται στο πλαίσιο του
                {" "}
                <Link href="https://greece20.gov.gr/" isExternal color={linkColor} fontWeight={600}>
                    Εθνικού Σχεδίου Ανάκαμψης και Ανθεκτικότητας Ελλάδα 2.0 με τη χρηματοδότηση της Ευρωπαϊκής Ένωσης – NextGenerationEU
                </Link>
                .
            </Text>
        </Box>
    );
}
